import { render, staticRenderFns } from "./HomeCandidato.vue?vue&type=template&id=f6d8cdee&scoped=true"
import script from "./HomeCandidato.vue?vue&type=script&lang=js"
export * from "./HomeCandidato.vue?vue&type=script&lang=js"
import style0 from "./HomeCandidato.vue?vue&type=style&index=0&id=f6d8cdee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d8cdee",
  null
  
)

export default component.exports